
        module.exports = __webpack_public_path__ + "assets/images/header.bae4b96c.jpg";;

        var src = '' + module.exports;

        module.exports = {

            src: src,
            width: 1920,
            height: 805,
            type: "jpg",
            bytes: 306473,

            toString: function() {
                return src;
            }
        };
    